"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.romanize = void 0;
const KEY = [
    '',
    'C',
    'CC',
    'CCC',
    'CD',
    'D',
    'DC',
    'DCC',
    'DCCC',
    'CM',
    '',
    'X',
    'XX',
    'XXX',
    'XL',
    'L',
    'LX',
    'LXX',
    'LXXX',
    'XC',
    '',
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX'
];
function romanize(num) {
    if (isNaN(num)) {
        return NaN;
    }
    let digits = String(+num).split(''), roman = '', i = 3;
    while (i--) {
        roman = (KEY[+digits.pop() + i * 10] || '') + roman;
    }
    return Array(+digits.join('') + 1).join('M') + roman;
}
exports.romanize = romanize;
//# sourceMappingURL=romanize.js.map